<template>
    <div class="edit-template" v-show="edit_template">
        <ColorList
            :colorList="colorList"
            :showColorList="showColorList"
            :colorListValue="colorListValue"
            :checkDefaultValue="true"
            :selectedDefaultHex="selectedDefaultHex"
            :closeEdit="closeColorList"
            :canvasActiveObj="canvasActiveObject"
            :value="color"
            v-on:set-value="handleColorSelection"
            @undoAndRedoImageColor="saveCanvasDataInColor"
            @triggerLoaderGrandChild="triggerLoaderGrandChild"
            :vendor_colors_list="vendor_colors_list"
            :has-service-color-type="hasServiceColorType"
            :decorationType="decorationType"
        />

        <div
            v-show="!colorList"
            class="tools_headding catgory_headding w-100 add_txt heading-pd"
        >
            <a
                href="#"
                @click="closeEdit(selectedType)"
                class="text_primary_blue d-flex w-100"
                ><img
                    src="/maincss/images/tool_back_arrow.svg"
                    alt=" "
                    class="mr_12"
                />
                <h4 class="heading5">
                    Edit
                    {{
                        selectedType == "clipart"
                            ? "Clipart"
                            : selectedType == "templates"
                            ? "Template"
                            : selectedType == "shape"
                            ? "Shape"
                            : selectedType == "patch"
                            ? "Patch"
                            : ""
                    }}
                </h4>
            </a>
            <a
                href="#"
                @click="closeEdit(selectedType)"
                title="Close"
                class="ml-auto"
                ><img src="/maincss/images/tool_close.svg" alt=" "
            /></a>
        </div>
        <div v-show="!colorList" class="rt-edit-template">
            <div class="center_layering_filip">
                <Layering :value="layer" v-on:set-value="setLayer" />
                <Center
                    :showLabel="true"
                    :setClass="setClass"
                    :value="center"
                    v-on:set-value="setCenter"
                />

                <Flip
                    :flip-x="flipX"
                    :flip-y="flipY"
                    v-on:set-value="setFlip"
                />

                <Duplicate
                    :setClass="setClass"
                    v-on:set-value="addDuplicate"
                    :value="text"
                />
            </div>

            <br /><br />
            <Rotation
                :mTop="0"
                :value="rotation"
                v-on:set-value="setRotation"
            />

            <!-- Stroke Width Control (Only for Shapes) -->
            <div
                v-if="selectedType === 'shape'"
                class="custome_div addtext_rotation_wrap"
                style="margin-top: 20px"
            >
                <div class="addtext_font rotation add_font_mobile_w">
                    <div class="form-group">
                        <div class="range">
                            <!-- eslint-disable -->
                            <input
                                v-model="strokeWidth"
                                v-on:change="setStrokeWidth"
                                id="strokeWidthValue"
                                type="range"
                                min="0"
                                max="100"
                                class="input_type_rang_custom"
                            />
                            <!-- eslint-enable -->
                        </div>
                        <label>Outline Width</label
                        ><span class="highlight"></span>
                    </div>
                </div>

                <div :class="'addtext_color font-size_add rot_value outline_width'">
                    <div class="form-group">
                        <!-- eslint-disable -->
                        <input
                            v-on:change="setStrokeWidth"
                            type="number"
                            v-model="strokeWidth"
                            id="strokeWidthValueInput"
                            required="required"
                            placeholder="3"
                            min="0"
                            max="100"
                            class="range_slider_input span2 form-control bg-whit"
                        />
                        <!-- eslint-enable -->
                    </div>
                </div>
            </div>
        </div>
        <div v-show="!colorList" class="well p-0 m-0">
            <div class="form-group frm-grp-temp templ_studio bg_transparent">
                <div class="temp-color">
                    <input
                        type="text"
                        disabled="true"
                        required="required"
                        placeholder="Colors"
                        class="span2 form-control bg-transparent text_input_pad"
                    /><!-- id="text-string" -->
                </div>
                <div class="color_boxes">
                    <ColorBox
                        v-for="(c, index) in colorListValue.length
                            ? colorListValue.length > 8
                                ? colorListValue.slice(0, 8)
                                : colorListValue
                            : [color]"
                        :key="index"
                        :showLabel="showLabel"
                        :value="c"
                        v-on:set-value="(color) => showColorList(color, index)"
                    />
                    <div class="more_colors" v-show="colorListValue.length > 8">
                        <a v-on:set-value="showColorList" href="#"
                            >+{{ colorListValue.slice(8).length }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
    <script>
import { fabric } from "fabric";
import canvas from "html2canvas";
import Duplicate from "../components/Duplicate";
import Rotation from "../components/Rotation";
import Layering from "../components/Layering";
import Flip from "../components/Flip";
import Center from "../components/Center";
import ColorBox from "../components/ColorBox";
import ColorList from "../components/ColorListV3";
const rgba2hex = (rgba) =>
    `#${rgba
        .match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/)
        .slice(1)
        .map((n, i) =>
            (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n))
                .toString(16)
                .padStart(2, "0")
                .replace("NaN", "")
        )
        .join("")}`;
export default {
    name: "ClipSetting",
    components: {
        Rotation,
        Duplicate,
        Layering,
        Flip,
        Center,
        ColorBox,
        ColorList
    },

    data: () => {
        return {
            setClass: "to_center",
            text: "",
            stroke: "",
            fontFamily: "Arial",
            fontStyle: "",
            fontSize: 50,
            color: "#000000",
            rotation: 0,
            textAlign: "left",
            textDecoration: "",
            fontWeight: "",
            layer: "",
            flip: "",
            flipX: false,
            flipY: false,
            center: "",
            setMargineZero: "set_margine_zero",
            showLabel: false,
            colorList: false,
            colorListValue: [],
            prevAngle: 0,
            selectedDefaultHex: "",
            selectedColorIndex: null,
            strokeWidth: 3
        };
    },
    emits: ["set-value"],
    props: [
        "data",
        "edit_template",
        "selectedType",
        "closeEdit",
        "showMenu",
        "addDeleteBtn",
        "canvasActiveObject",
        "selectedObjectColors",
        "rotationAngle",
        "vendor_colors_list",
        "hasServiceColorType",
        "decorationType",
        "printAreaBond",
        "active_flip"
    ],
    watch: {
        edit_template: function (value) {
            this.colorList = false;
            if (value) {
                this.showColorFromList();
                // Initialize outline color and stroke width for shapes
                if (this.selectedType === "shape") {
                    this.initializeStrokeWidth(); // Initialize stroke width first
                    this.initializeOutlineColor();
                }
            }
        },
        selectedObjectColors: function () {
            this.colorList = false;
            this.showColorFromList();
        },
        data: function (newData, oldData) {
            if (JSON.stringify(newData) != JSON.stringify(oldData)) {
                this.showColorFromList();
                let {
                    text,
                    fontFamily,
                    fontStyle,
                    fontSize,
                    color,
                    rotation,
                    textAlign,
                    layer,
                    flip,
                    center,
                    flipX,
                    flipY,
                    textDecoration,
                    fontWeight
                } = newData;
                this.text = text;
                this.fontFamily = fontFamily;
                this.fontStyle = fontStyle;
                this.textDecoration = textDecoration;
                this.fontWeight = fontWeight;
                this.fontSize = fontSize;
                this.color = color;
                this.rotation = rotation;
                this.textAlign = textAlign;
                this.layer = layer;
                this.flip = flip;
                this.center =
                    center !== undefined && center !== null && center !== ""
                        ? center
                        : "left";
                if (Object.prototype.hasOwnProperty.call(newData, "flipX")) {
                    this.flipX =
                        typeof flipX === "boolean"
                            ? flipX
                            : flipX != null
                              ? !!flipX
                              : false;
                }
                if (Object.prototype.hasOwnProperty.call(newData, "flipY")) {
                    this.flipY =
                        typeof flipY === "boolean"
                            ? flipY
                            : flipY != null
                              ? !!flipY
                              : false;
                }
            }
        },
        rotationAngle: function (newData, oldData) {
            if (newData != oldData) this.rotation = Math.ceil(newData);
        }
    },
    methods: {
        triggerLoaderGrandChild(currentStatus) {
            this.$emit("triggerLoader", currentStatus);
        },
        setText(value) {
            if (
                !this.text.length &&
                !this.canvasActiveObject.getActiveObject()
            ) {
                /* eslint-disable */
                var textSample = new fabric.Text("", {
                    id: new Date() / 1,
                    left: LEFT_OFFSET,
                    top: TOP_OFFSET,
                    fontFamily: "Arial",
                    angle: 0,
                    fill: "#000000",
                    fontSize: 50,
                    scaleX: 0.5,
                    scaleY: 0.5,
                    padding: 0,
                    hasRotatingPoint: true
                });
                /* eslint-enable */
                this.canvasActiveObject.add(textSample);
                this.canvasActiveObject.setActiveObject(textSample);
                var item = this.canvasActiveObject.item(
                    this.canvasActiveObject.item.length - 1
                );
                item.hasRotatingPoint = true;

                this.addDeleteBtn(item.left, item.top, item.width, item);
                // item.active = true;
            }

            this.text = value;

            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();

            if (activeObject) {
                activeObject.text = this.text;
                this.canvasActiveObject.renderAll();
                this.addDeleteBtn(
                    activeObject.left,
                    activeObject.top,
                    activeObject.width,
                    activeObject
                );
            }
        },
        enabled() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getActive() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject) {
                    return "Edit Text";
                } else {
                    return "Add Text";
                }
            } else {
                return "Add Text";
            }
        },
        setFontType(value) {
            this.fontFamily = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontFamily = this.fontFamily;
                this.canvasActiveObject.renderAll();
            }
        },
        rgbToHex(rgbColorString) {
            const rgbValues = rgbColorString.match(/\d+/g);

            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString.toLowerCase();
            }

            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value

            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));

            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");

            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;

            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        showColorFromList() {
            /* eslint-disable */
            this.selectedObjectColors.forEach((colorHex, i) => {
                if (colorHex.includes("rgb")) {
                    this.selectedObjectColors[i] = this.rgbToHex(colorHex);
                }
            });
            /* eslint-enable */
            this.colorListValue = this.selectedObjectColors;

            // For shapes, ensure we have fill and outline colors
            if (this.selectedType === "shape") {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject && activeObject.ctype === "shape") {
                    // For complex shapes with _objects, get colors from _objects
                    if (activeObject._objects && activeObject._objects.length) {
                        // Extract unique fill colors from _objects
                        var fillColors = [];
                        var strokeColors = [];
                        activeObject._objects.forEach(function (obj) {
                            if (
                                obj.fill &&
                                obj.fill !== "transparent" &&
                                obj.fill !== "none" &&
                                obj.fill !== ""
                            ) {
                                fillColors.push(obj.fill);
                            }
                            if (
                                obj.stroke &&
                                obj.stroke !== "transparent" &&
                                obj.stroke !== "none" &&
                                obj.stroke !== ""
                            ) {
                                strokeColors.push(obj.stroke);
                            }
                        });
                        // Use first fill color and first stroke color
                        var fillColor =
                            fillColors.length > 0
                                ? fillColors[0]
                                : activeObject.fill || "#000000";
                        var outlineColor =
                            strokeColors.length > 0
                                ? strokeColors[0]
                                : activeObject.stroke || "#000000";

                        // Update colorListValue
                        this.colorListValue = [fillColor];
                        if (
                            outlineColor &&
                            outlineColor !== "transparent" &&
                            outlineColor !== "none" &&
                            outlineColor !== ""
                        ) {
                            this.colorListValue.push(outlineColor);
                        }
                    } else {
                        // Simple shape - use main object's fill and stroke
                        var fillColor = activeObject.fill || "#000000";
                        var outlineColor = activeObject.stroke;

                        // Update colorListValue
                        this.colorListValue = [fillColor];
                        if (
                            outlineColor &&
                            outlineColor !== "transparent" &&
                            outlineColor !== "none" &&
                            outlineColor !== ""
                        ) {
                            if (this.colorListValue.length === 1) {
                                this.colorListValue.push(outlineColor);
                            } else {
                                this.colorListValue[1] = outlineColor;
                            }
                        }
                    }
                }
            }
        },
        showColorFromListOld() {
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                this.colorListValue = [];
                var colorListValue = [];
                if (activeObject._objects && activeObject._objects.length) {
                    fabric.Object.prototype.objectCaching = false;
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    var matchColors =
                        /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    activeObject._objects.forEach(function (e) {
                        let hexColor = "";

                        if (matchColors.exec(e.fill)) {
                            hexColor = rgba2hex(e.fill);
                        }
                        if (reg.test(e.fill) || hexColor) {
                            colorListValue.push(e.fill);
                        }
                    });
                    this.colorListValue = [...new Set(colorListValue)];
                } else {
                    this.colorListValue = [];
                }
            }
            if (activeObject.paths && activeObject.paths.length) {
                colorListValue.push(activeObject.fill);
                this.colorListValue = [...new Set(colorListValue)];
            }
        },
        showColorList(hex = null, colorIndex = null) {
            this.showColorFromList();
            this.colorList = true;
            this.selectedDefaultHex = hex;
            // Store which color index was clicked (for shapes: 0=fill, 1=outline)
            if (colorIndex !== null && colorIndex !== undefined) {
                this.selectedColorIndex = colorIndex;
            }
        },
        handleColorSelection(color, oldColor, colorIndex = null) {
            // This method receives color from ColorList
            // For shapes, use the colorIndex passed from ColorListV3
            if (this.selectedType === "shape") {
                if (colorIndex !== null && colorIndex !== undefined) {
                    // Use the index passed from ColorListV3
                    this.selectedColorIndex = colorIndex;
                } else {
                    // Fallback: Find which color in colorListValue matches oldColor
                    var oldColorIndex = this.colorListValue.indexOf(oldColor);
                    if (oldColorIndex !== -1) {
                        this.selectedColorIndex = oldColorIndex;
                    } else {
                        // Default to 0 (fill color)
                        this.selectedColorIndex = 0;
                    }
                }
            }
            this.setColor(color, oldColor);
        },
        closeColorList() {
            this.colorList = false;
        },
        setColor(value, oldColour) {
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                // For shapes, check which color was selected (first or second)
                if (
                    this.selectedType === "shape" &&
                    activeObject.ctype === "shape"
                ) {
                    var colorIndex = null;

                    // Method 1: Use selectedColorIndex if set
                    if (
                        this.selectedColorIndex !== null &&
                        this.selectedColorIndex !== undefined
                    ) {
                        colorIndex = this.selectedColorIndex;
                    }
                    // Method 2: Find index from oldColour in colorListValue
                    else if (oldColour) {
                        colorIndex = this.colorListValue.indexOf(oldColour);
                    }
                    // Method 3: Find index from new value (if it already exists in list)
                    else {
                        colorIndex = this.colorListValue.indexOf(value);
                    }

                    // If still not found, default to 0 (fill color)
                    if (
                        colorIndex === -1 ||
                        colorIndex === null ||
                        colorIndex === undefined
                    ) {
                        colorIndex = 0;
                    }

                    console.log(
                        "Shape Color Update - Index:",
                        colorIndex,
                        "New Color:",
                        value,
                        "Old Color:",
                        oldColour,
                        "Color List:",
                        this.colorListValue
                    );

                    if (colorIndex === 0) {
                        // First color = Fill color
                        activeObject.fill = value;
                        // For complex shapes with _objects (like cross), update fill for each path
                        if (
                            activeObject._objects &&
                            activeObject._objects.length
                        ) {
                            activeObject._objects.forEach(function (obj) {
                                obj.fill = value;
                            });
                        }
                        this.colorListValue[0] = value;
                        this.color = value;
                    } else if (colorIndex === 1) {
                        // Second color = Outline color
                        activeObject.set({
                            stroke: value,
                            strokeWidth: this.strokeWidth || 3,
                            strokeLineCap: "round",
                            strokeLineJoin: "round"
                        });
                        // For complex shapes with _objects (like cross), update stroke for each path
                        if (
                            activeObject._objects &&
                            activeObject._objects.length
                        ) {
                            activeObject._objects.forEach(
                                function (obj) {
                                    obj.set({
                                        stroke: value,
                                        strokeWidth: this.strokeWidth || 3,
                                        strokeLineCap: "round",
                                        strokeLineJoin: "round"
                                    });
                                }.bind(this)
                            );
                        }
                        // Ensure we have 2 colors in list
                        if (this.colorListValue.length === 1) {
                            this.colorListValue.push(value);
                        } else if (this.colorListValue.length > 1) {
                            this.colorListValue[1] = value;
                        }
                        this.stroke = value;
                    } else {
                        // Default: update fill (first color)
                        activeObject.fill = value;
                        // For complex shapes with _objects (like cross), update fill for each path
                        if (
                            activeObject._objects &&
                            activeObject._objects.length
                        ) {
                            activeObject._objects.forEach(function (obj) {
                                obj.fill = value;
                            });
                        }
                        if (this.colorListValue.length > 0) {
                            this.colorListValue[0] = value;
                        }
                        this.color = value;
                    }
                    // Reset selectedColorIndex after use
                    this.selectedColorIndex = null;
                    // Disable object caching for complex shapes to ensure proper rendering
                    this.canvasActiveObject.objectCaching = false;
                } else {
                    // Non-shape: normal fill color update
                    this.color = value;
                    activeObject.fill = this.color;
                    if (this.colorListValue.length > 0) {
                        this.colorListValue[0] = this.color;
                    }
                }

                this.canvasActiveObject.renderAll();
                // Save to undo/redo stack for shape color changes
                // Note: For complex shapes, ColorListV3 also emits undoAndRedoImageColor,
                // but this ensures simple shapes are also saved
                if (
                    this.selectedType === "shape" &&
                    activeObject &&
                    activeObject.ctype === "shape"
                ) {
                    this.$emit("undoAndRedo");
                }
            }
        },
        setOutline(value) {
            this.stroke = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                // For shapes, set stroke and strokeWidth
                if (
                    this.selectedType === "shape" &&
                    activeObject.ctype === "shape"
                ) {
                    activeObject.set({
                        stroke: this.stroke,
                        strokeWidth: this.strokeWidth || 3,
                        strokeLineCap: "round",
                        strokeLineJoin: "round"
                    });
                    // For complex shapes with _objects (like cross), update stroke for each path
                    if (activeObject._objects && activeObject._objects.length) {
                        activeObject._objects.forEach(
                            function (obj) {
                                obj.set({
                                    stroke: this.stroke,
                                    strokeWidth: this.strokeWidth || 3,
                                    strokeLineCap: "round",
                                    strokeLineJoin: "round"
                                });
                            }.bind(this)
                        );
                    }
                } else {
                    activeObject.stroke = this.stroke;
                }
                this.canvasActiveObject.renderAll();
            }
        },
        setStrokeWidth(e) {
            var newWidth = Number(e.target.value);
            // Clamp value between 1 and 100
            if (newWidth < 1) newWidth = 1;
            if (newWidth > 100) newWidth = 100;

            this.strokeWidth = newWidth;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (
                activeObject &&
                this.selectedType === "shape" &&
                activeObject.ctype === "shape"
            ) {
                // Update stroke width for main object
                activeObject.set({
                    strokeWidth: this.strokeWidth,
                    strokeLineCap: "round",
                    strokeLineJoin: "round"
                });
                // For complex shapes with _objects (like cross), update stroke width for each path
                if (activeObject._objects && activeObject._objects.length) {
                    activeObject._objects.forEach(
                        function (obj) {
                            obj.set({
                                strokeWidth: this.strokeWidth,
                                strokeLineCap: "round",
                                strokeLineJoin: "round"
                            });
                        }.bind(this)
                    );
                }
                // Disable object caching for proper rendering
                fabric.Object.prototype.objectCaching = false;
                this.canvasActiveObject.renderAll();
                // Save to undo/redo stack
                this.$emit("undoAndRedo");
            }
        },
        initializeStrokeWidth() {
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.ctype === "shape") {
                // Get stroke width from active object (check _objects first for complex shapes)
                if (activeObject._objects && activeObject._objects.length) {
                    // Get stroke width from first object that has stroke
                    var firstObjWithStroke = activeObject._objects.find(
                        function (obj) {
                            return (
                                obj.strokeWidth !== undefined &&
                                obj.strokeWidth !== null
                            );
                        }
                    );
                    if (firstObjWithStroke && firstObjWithStroke.strokeWidth) {
                        this.strokeWidth = firstObjWithStroke.strokeWidth;
                    } else if (activeObject.strokeWidth) {
                        this.strokeWidth = activeObject.strokeWidth;
                    } else {
                        this.strokeWidth = 3; // Default
                    }
                } else if (activeObject.strokeWidth) {
                    this.strokeWidth = activeObject.strokeWidth;
                } else {
                    this.strokeWidth = 3; // Default
                }
            }
        },
        initializeOutlineColor() {
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.ctype === "shape") {
                // For complex shapes, check _objects first
                if (activeObject._objects && activeObject._objects.length) {
                    var firstObjWithStroke = activeObject._objects.find(
                        function (obj) {
                            return (
                                obj.stroke &&
                                obj.stroke !== "transparent" &&
                                obj.stroke !== "none" &&
                                obj.stroke !== ""
                            );
                        }
                    );
                    if (firstObjWithStroke && firstObjWithStroke.stroke) {
                        this.stroke = firstObjWithStroke.stroke;
                    } else if (activeObject.stroke) {
                        this.stroke = activeObject.stroke;
                    } else {
                        // Set default outline if not present
                        this.stroke = "#000000";
                        activeObject.set({
                            stroke: "#000000",
                            strokeWidth: this.strokeWidth || 3
                        });
                        // Apply to _objects as well
                        activeObject._objects.forEach(
                            function (obj) {
                                obj.set({
                                    stroke: "#000000",
                                    strokeWidth: this.strokeWidth || 3
                                });
                            }.bind(this)
                        );
                        this.canvasActiveObject.renderAll();
                    }
                } else {
                    if (activeObject.stroke) {
                        this.stroke = activeObject.stroke;
                    } else {
                        // Set default outline if not present
                        this.stroke = "#000000";
                        activeObject.set({
                            stroke: "#000000",
                            strokeWidth: this.strokeWidth || 3
                        });
                        this.canvasActiveObject.renderAll();
                    }
                }
            }
        },
        setFontStyle(value) {
            this.fontStyle = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontStyle = this.fontStyle;
                this.canvasActiveObject.renderAll();
            }
        },

        setTextDecoration(value) {
            this.textDecoration = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.textDecoration = this.textDecoration;
                this.canvasActiveObject.renderAll();
            }
        },
        setFontWeight(value) {
            this.fontWeight = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontWeight = this.fontWeight;
                this.canvasActiveObject.renderAll();
            }
        },

        setFontSize(value) {
            this.fontSize = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontSize = Number(this.fontSize);
                this.canvasActiveObject.renderAll();
            }
        },
        setRotation(value) {
            this.rotation = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.originX = "center";
                activeObject.originY = "center";

                if (Number(this.rotation) == 0) {
                    activeObject.angle = 0.01;
                } else {
                    activeObject.angle = Number(this.rotation);
                }
                //activeObject.setAngle(Number(this.rotation))
                let e = {
                    target: activeObject
                };
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
                this.addDeleteBtn(
                    e.target.oCoords.mtr.x,
                    e.target.oCoords.mtr.y,
                    e.target.width,
                    e.target
                );
            }
        },
        setTextAlign(value) {
            this.textAlign = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.textAlign = this.textAlign;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },

        setCenter(e) {
            if (!this.canvasActiveObject) {
                return;
            }

            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                this.center = e;
                if (e == "center") {
                    // Use print area (imprint box), not Fabric centerH() — centerH() uses full canvas
                    // and disagrees with left/right which use printAreaBond.
                    if (
                        this.printAreaBond &&
                        typeof this.printAreaBond.left === "number" &&
                        !isNaN(this.printAreaBond.width) &&
                        this.printAreaBond.width > 0
                    ) {
                        this.process_align("centerH", activeObject);
                    } else {
                        activeObject.centerH();
                    }
                    activeObject.setCoords();
                    this.canvasActiveObject.renderAll();
                }
                if (e == "left" || e == "right") {
                    this.process_align(e, activeObject);
                    activeObject.setCoords();

                    this.canvasActiveObject.renderAll();
                }
                this.addDeleteBtn(
                    activeObject.oCoords.mtr.x,
                    activeObject.oCoords.mtr.y,
                    activeObject.width,
                    activeObject
                );
            }
            this.$emit("undoAndRedo");
        },

        // process_align(val, activeObj) {
        //     //  var canvas = new fabric.Canvas('c');
        //     let bound = activeObj.getBoundingRect();
        //     switch (val) {
        //         case "left":
        //             activeObj.set({
        //                 left: activeObj.left - bound.left
        //             });
        //             break;
        //         case "right":
        //             if (activeObj.angle == 0) {
        //                 activeObj.set({
        //                     left: activeObj.canvas.width - bound.width / 2 - 5
        //                 });
        //             } else {
        //                 activeObj.set({
        //                     left: activeObj.canvas.width - bound.width / 2
        //                 });
        //             }
        //             break;
        //         case "top":
        //             activeObj.set({
        //                 top: activeObj.top - bound.top
        //             });
        //             break;
        //         case "bottom":
        //             activeObj.set({
        //                 top: canvas.height - bound.height / 2
        //             });
        //             break;
        //         case "centerH":
        //             activeObj.viewportCenterH();
        //             break;
        //         case "centerV":
        //             activeObj.viewportCenterV();
        //             break;
        //     }
        //     this.$emit("undoAndRedo");
        // },

        process_align(val, activeObj) {
            let bound = activeObj.getBoundingRect();

            // Get print area boundaries
            const printArea = this.printAreaBond;

            // Calculate the offset between object center and bounding rect
            const offsetX = activeObj.left - (bound.left + bound.width / 2);
            const offsetY = activeObj.top - (bound.top + bound.height / 2);

            switch (val) {
                case "left":
                    if (
                        this.active_flip == "front" ||
                        this.active_flip == "back"
                    ) {
                        // Align object's left edge to print area's left edge
                        const leftCenterX =
                            printArea.left + bound.width / 2 + offsetX;
                        activeObj.set({
                            left: leftCenterX
                        });
                    } else {
                        activeObj.set({
                            left: activeObj.left - bound.left
                        });
                    }
                    break;

                case "right":
                    if (
                        this.active_flip == "front" ||
                        this.active_flip == "back"
                    ) {
                        // Align object's right edge to print area's right edge
                        const rightCenterX =
                            printArea.left +
                            printArea.width -
                            bound.width / 2 +
                            offsetX;
                        activeObj.set({
                            left: rightCenterX
                        });
                        console.log(
                            "Setting right center position to:",
                            rightCenterX
                        );
                    } else {
                        if (activeObj.angle == 0) {
                            activeObj.set({
                                left:
                                    activeObj.canvas.width - bound.width / 2 - 5
                            });
                        } else {
                            activeObj.set({
                                left: activeObj.canvas.width - bound.width / 2
                            });
                        }
                    }
                    break;

                case "top":
                    // Align object's top edge to print area's top edge
                    const topCenterY =
                        printArea.top + bound.height / 2 + offsetY;
                    activeObj.set({
                        top: topCenterY
                    });
                    break;

                case "bottom":
                    // Align object's bottom edge to print area's bottom edge
                    const bottomCenterY =
                        printArea.top +
                        printArea.height -
                        bound.height / 2 +
                        offsetY;
                    activeObj.set({
                        top: bottomCenterY
                    });
                    break;

                case "centerH":
                    // Center horizontally within print area
                    const centerX =
                        printArea.left + printArea.width / 2 + offsetX;
                    activeObj.set({
                        left: centerX
                    });
                    break;

                case "centerV":
                    // Center vertically within print area
                    const centerY =
                        printArea.top + printArea.height / 2 + offsetY;
                    activeObj.set({
                        top: centerY
                    });
                    break;
            }

            this.$emit("undoAndRedo");
        },
        setLayer(value) {
            var _this = this;
            _this.layer = value;
            if (!_this.canvasActiveObject) {
                return;
            }
            var activeObject = _this.canvasActiveObject.getActiveObject(),
                activeGroup = _this.canvasActiveObject.getActiveObject();
            _this.canvasActiveObject.preserveObjectStacking = true;
            if (activeObject) {
                if (_this.layer == "front") activeObject.bringToFront();
                else if (_this.layer == "back") {
                    activeObject.sendToBack();
                }
                _this.canvasActiveObject.renderAll();
            } else if (activeGroup) {
                var objectsInGroup = activeGroup.getObjects();
                _this.canvasActiveObject.discardActiveGroup();
                objectsInGroup.forEach(function (object) {
                    if (_this.layer == "front") object.bringToFront();
                    else if (_this.layer == "back") {
                        object.sendToBack();
                    }
                });
            }
            this.$emit("undoAndRedo");
        },
        saveCanvasDataInColor() {
            this.$emit("undoAndRedo");
        },
        setFlip(e) {
            // this.flip=""
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                if (e == "left") {
                    activeObject.flipX = activeObject.flipX ? false : true;
                } else if (e == "top") {
                    activeObject.flipY = activeObject.flipY ? false : true;
                }
                this.flipX = !!activeObject.flipX;
                this.flipY = !!activeObject.flipY;
                this.canvasActiveObject.renderAll();
            }
            this.$emit("undoAndRedo");
        },
        addDuplicate() {
            //placeText()
            let _this = this;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.clone(function (cobj) {
                    cobj.set("top", cobj.top + 20);
                    cobj.set("left", cobj.left + 20);
                    _this.canvasActiveObject.add(cobj);
                    _this.canvasActiveObject.renderAll();
                    this.$emit("undoAndRedo");
                });
            }
        }
    }
};
</script>
    
    <style>
.a_disabled button {
    cursor: not-allowed;
}

.to_center {
    flex-direction: column;
    display: flex;
    width: 100%;
}

.to_center > button {
    margin: auto;
}

.set_margine_zero {
    margin: 0 !important;
}

.setwidth_top_margin {
    width: 28% !important;
    margin-top: 0 !important;
}

/* Stroke Width Slider Styling - Same as Rotation Slider */
.addtext_font
    .range
    input#strokeWidthValue[type="range"]::-webkit-slider-thumb:after {
    content: "";
    position: absolute;
    top: 0px;
    height: 100%;
    left: 50%;
    width: 1px;
    background: #000;
}

.addtext_font .range input#strokeWidthValue::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    box-shadow: 1px 1px 1px #707070;
    background: #707070;
    border-radius: 5px;
    border: 1px solid #707070;
}

.addtext_font .range input#strokeWidthValue::-webkit-slider-thumb {
    height: 24px;
    width: 22px;
    border-radius: 13px;
    background: #ffffff;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -14px;
    border: none !important;
}

.design_studio_up .clipart_panel .center_layering_filip .bcommon{
        min-height: 35px;
}
.design_studio_up .design_panel_new .center_layering_filip .bcommon{
        min-height: 35px;
}
  .design_studio_up .design_studio_tool .rt-edit-template .center_layering_filip{
            border-bottom: 1px solid #BEBEBE99;
            padding-bottom: 20px;
    }
    .design_studio_up .clipart_panel .frm-grp-temp{
            margin-top: 0px;
            border-bottom: 1px solid #BEBEBE99 !important;
      }
</style>
    